// src/pages/HRMSSoftware.js
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
 
/* ------------------- CONTACT FORM ------------------- */
const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    countrycode: "",
    phone: "",
    location: "",
    no_of_employees: "",
    no_of_branches: "",
    product_taking_time: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
 
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
 
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setStatus({
        type: "success",
        msg: "Thank you! We will contact you soon.",
      });
    }, 1200);
  };
 
  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <input
          className="input-style"
          placeholder="Full Name"
          name="name"
          onChange={handleChange}
          required
        />
        <input
          className="input-style"
          placeholder="Email Address"
          name="email"
          type="email"
          onChange={handleChange}
          required
        />
        <input
          className="input-style"
          placeholder="Country Code"
          name="countrycode"
          onChange={handleChange}
          required
        />
        <input
          className="input-style"
          placeholder="Phone Number"
          name="phone"
          onChange={handleChange}
          required
        />
        <input
          className="input-style md:col-span-2"
          placeholder="Location"
          name="location"
          onChange={handleChange}
          required
        />
        <input
          className="input-style md:col-span-2"
          placeholder="No. of Employees"
          name="no_of_employees"
          onChange={handleChange}
          required
        />
        <input
          className="input-style md:col-span-2"
          placeholder="No. of Branches"
          name="no_of_branches"
          onChange={handleChange}
          required
        />
        <input
          className="input-style md:col-span-2"
          placeholder="When do you plan to start?"
          name="product_taking_time"
          onChange={handleChange}
          required
        />
      </div>
      <button className="btn-primary w-full" disabled={submitting}>
        {submitting ? "Submitting..." : "Request Demo"}
      </button>
      {status && (
        <p
          className={`text-center ${
            status.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {status.msg}
        </p>
      )}
    </form>
  );
};
 
/* ------------------- MAIN PAGE ------------------- */
const HRMSSoftware = () => {
  return (
    <>
      <Helmet>
        <title>HRMS Software | Human Resource Management System</title>
        <meta
          name="description"
          content="Full-featured HRMS platform for payroll, attendance, onboarding, and performance."
        />
      </Helmet>
      <Navbar />
 
 
      {/* -------------------------------- HERO SECTION -------------------------------- */}
      <section className="w-full bg-white pt-1 pb-1 px-5 md:px-20 flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2">
          <img src="/img/360.png" alt="Logo" className="w-32 mb-1" />

          <h1 className="text-4xl md:text-5xl font-bold leading-snug">
          HR Management System for Today’s Modern Workplaces


          </h1>

          <p className="mt-2 text-gray-600 max-w-md">
         
A modern Human Resource Management System designed to streamline recruitment, attendance, payroll and employee records, delivering secure, seamless and fully automated HR operations for today’s workplaces.


          </p>
        </div>

       <div className="md:w-1/2">
  <img
    src="/img/shrava360 (5).png"
    alt="Hero"
    className="w-full rounded-2xl shadow-lg object-cover object-[center_15%]"
  />
</div>

      </section>
      {/* -------------------------------- BENEFITS SECTION (UPDATED) -------------------------------- */}
      <section
        className="relative bg-[#0f0d1f] py-24 text-white overflow-hidden"
        style={{
          backgroundImage: "url('/img/pipes.png')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 px-6 relative z-10">
          {/* Left Image */}
          <div className="relative">
            <img
              src="/img/hrms2.png"
              className="rounded-xl shadow-2xl"
              alt="HRMS Dashboard"
            />
            <img
              src="/img/hrms1.png"
              className="absolute -top-6 -left-6 rounded-xl shadow-xl"
              alt="Preview"
            />
          </div>
 
          {/* Right Text Content - NEW CONTENT */}
          <div className="">
            <h2 className="text-4xl font-extrabold mb-6">
              Benefits of a Human Resource Management System
            </h2>
            <p className="text-xl text-gray-300 mb-12">
              Streamline HR, empower employees and drive organisational success
            </p>
 
            <div className="space-y-10">
              {/* Hiring & Onboarding */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  1
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Hiring & Onboarding
                  </h3>
                  <p className="text-gray-400">
                    Automate recruitment and onboarding to ensure faster and
                    smoother employee integration
                  </p>
                </div>
              </div>
 
              {/* Attendance & Leave */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  2
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Attendance & Leave
                  </h3>
                  <p className="text-gray-400">
                    Track attendance and leave requests to reduce daily
                    administrative workload efficiently
                  </p>
                </div>
              </div>
 
              {/* Payroll & Compensation */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  3
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Payroll & Compensation
                  </h3>
                  <p className="text-gray-400">
                    Process salaries, bonuses, and taxes accurately for timely
                    employee payments always
                  </p>
                </div>
              </div>
 
              {/* Employee Data & Performance */}
              <div className="flex gap-6">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center text-2xl font-bold">
                  4.
                </div>
                <div>
                  <h3 className="text-2xl font-semibold mb-2">
                    Employee Data & Performance
                  </h3>
                  <p className="text-gray-400">
                    Manage records securely and monitor employee performance to
                    support consistent growth
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* -------------------------------- FEATURES SECTION – ACCORDION WITH ICON -------------------------------- */}
      <section className="relative bg-white pt-24 pb-40 overflow-hidden">
        <img
          src="/img/waves.png"
          alt="wave"
          className="absolute bottom-0 left-0 w-full pointer-events-none select-none"
        />
 
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* HEADING */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
              Complete HRMS Features for Efficient HR Operations
            </h2>
            <p className="mt-6 text-xl md:text-2xl text-gray-700 font-medium max-w-5xl mx-auto">
              A modular and advanced HRMS platform designed to streamline
              recruitment, attendance, payroll and employee records, delivering
              secure, seamless and fully automated HR operations across your
              organization.
            </p>
          </div>
 
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* LEFT: ACCORDION WITH ICON */}
            <div className="space-y-6">
              {/* Feature 1 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Employee Login & Attendance Tracking
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Secure login, role-based access, punch-in/out and
                    auto-alerts ensures accurate attendance and workforce
                    discipline.
                  </p>
                </div>
              </details>
 
              {/* Feature 2 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Automated Payslips & Employee Profiles
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Auto-generated salary slips, bonuses, tax deductions and
                    centralised records saves HR time and reduces errors.
                  </p>
                </div>
              </details>
 
              {/* Feature 3 */}
              <details className="group">
                <summary className="flex justify-between items-center py-6 px-8 bg-white border border-gray-200 rounded-2xl cursor-pointer list-none hover:bg-gray-50 transition">
                  <span className="text-2xl lg:text-1xl font-bold text-gray-800">
                    Recruitment & Onboarding
                  </span>
                  <svg
                    className="w-7 h-7 text-gray-500 transition-transform duration-300 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </summary>
                <div className="px-8 pb-8 pt-4">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Job posting, candidate screening, automated offer letters
                    and onboarding checklists ensures a smooth hiring process.
                  </p>
                </div>
              </details>
            </div>
 
            {/* RIGHT: IMAGES */}
            <div className="relative w-full flex justify-center lg:justify-end">
              <div className="absolute top-5 left-5 w-[85%] rounded-3xl overflow-hidden shadow-2xl opacity-90">
                <img
                  src="/img/hrms3.png"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div className="relative z-20 w-[90%] rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="/img/hrms4.png"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
              <div className="absolute bottom-[-20px] right-0 w-40 h-40 rounded-2xl overflow-hidden shadow-xl z-30">
                <img
                  src="/img/hrms5.jpg"
                  className="w-full h-full object-cover"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
 
      {/* -------------------------------- CONTACT SECTION -------------------------------- */}
      <section id="contact" className="py-24 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-gray-800">Get In Touch</h2>
          <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
            Ready to automate your HR? Request a free product demo today.
          </p>
          <div className="mt-12 bg-white p-10 rounded-3xl shadow-xl">
            <ContactForm />
          </div>
        </div>
      </section>
 
      <Footer />
 
      {/* Scroll to Top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-purple-700 text-white rounded-full shadow-lg hover:bg-purple-800 transition flex items-center justify-center"
      >
       
      </button>
    </>
  );
};
 
export default HRMSSoftware;
 
 